import { Component, effect, ElementRef, input, model, viewChild } from '@angular/core';
import { FormCheckboxControl } from '@angular/forms/signals';

@Component({
  selector: 'ui-checkbox',
  templateUrl: './checkbox.html',
})
export class Checkbox implements FormCheckboxControl {
  inputId = input<string | null>(null);

  readonly checked = model<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly touched = model<boolean>(false);
  readonly name = input<string>('');

  indeterminate = input<boolean>(false);

  checkbox = viewChild<ElementRef<HTMLInputElement>>('input');

  constructor() {
    effect(() => {
      const checkbox = this.checkbox()?.nativeElement;
      if (!checkbox) {
        return;
      }
      checkbox.indeterminate = this.indeterminate();
    });
  }

  protected onCheck(checked: boolean): void {
    this.checked.set(checked);
    this.touched.set(true);
  }
}
